module.exports = __webpack_public_path__ + "img/lpr_night_up_selected.5a1ed2b7.svg";